import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { LiveRecording, Paginated, RecordingStatus } from '../../models/live-recording.model';
export interface TrimRecordingPayload {
  filename: string;
  start: number;
  end: number;
}

export interface TrimRecordingResponse {
  message: string;
  item: {
    filename: string;
    path: string;
    duration: number | null;
  };
}
@Injectable({ providedIn: 'root' })
export class LiveRecordingsService {
  private base = environment.apiUrl; // მაგალითად: https://api.sca.ge/api

  constructor(private http: HttpClient) {}

  list(params?: {
    page?: number;
    status?: RecordingStatus | '';
    visible?: 0 | 1 | '';
  }): Observable<Paginated<LiveRecording>> {
    let hp = new HttpParams();

    if (params?.page) hp = hp.set('page', params.page);
    if (params?.status) hp = hp.set('status', params.status);
    if (params?.visible !== undefined && params?.visible !== '') hp = hp.set('visible', params.visible);

    // თუ შენს backend-ს prefix აქვს admin-ზე:
    return this.http.get<Paginated<LiveRecording>>(`${this.base}admin/live-recordings`, { params: hp });
  }

  updateRecordingTitle(id: number, data: { title: string; title_en: string }) {
    return this.http.post<{ success: boolean; item: any; message: string }>(
      `${this.base}admin/live-recordings/${id}/title`,
      data
    );
  }


  trimRecording(payload: TrimRecordingPayload): Observable<TrimRecordingResponse> {
    return this.http.post<TrimRecordingResponse>(`${this.base}admin/recordings/trim`, payload);
  }

  replaceRecording(payload: {
      original_filename: string;
      clip_filename: string;
    }) {
      return this.http.post(`${this.base}admin/recordings/replace`, payload);
    }


    deleteTempClip(filename: string) {
      return this.http.post(`${this.base}admin/recordings/delete-temp`, {
        filename
      });
    }

}